import {Stack} from "@mui/material";
import type {Transaction} from "../../../../../sdo/Transaction.ts";
import {SummaryPill, SummaryPillRow} from "../resolvers/editors/ResolverUtils.tsx";

interface TransactionViewProps {
    transaction: Transaction;
}

function TransactionView({transaction}: TransactionViewProps) {
    return (
        <Stack direction="column" spacing={0.5} sx={{width: "100%", maxWidth: 760, mx: "auto", alignItems: "stretch"}}>
            <SummaryPillRow>
                <SummaryPill label="Type" value={transaction.typeKey || "—"}/>
                <SummaryPill label="Extension" value={transaction.extensionKey || "—"}/>
            </SummaryPillRow>
            <SummaryPillRow>
                <SummaryPill label="Display" value={transaction.display || "—"}/>
            </SummaryPillRow>
        </Stack>
    );
}

export default TransactionView;
